export const types = {
  /* =================================== MOTO DRIVER ============================================= */

  authChecking: "[auth] Checking login state",
  authCheckingFinish: "[auth] Finish checking login state",
  authStartLogin: "[auth] Start login",
  authLogin: "[auth] Login",
  authStartRegister: "[auth] Start Register",
  authStartTokenRenew: "[auth] Start token renew",
  authLogout: "[auth] Logout",

  loaddingPageShow: "[loaddingPageShow] loaddingPageApiShow",
  loaddingPageNone: "[loaddingNone] loaddingPageApiNone",

  driversLoading: "[driver] Driver loading",
  driverActiveSelected: "[driver] driverActive selected",
  driverActiveClear: "[driver] driverActive clear",
  driverClearAll: "[driver] Driver clearAll",
  showTimingsDriver: "[driver] timings to driver",

  getZone: "[zones] getZone",
  getZoneSearch: "[zones] getZoneSearch",
  clearZone: "[zones] clearZone",

  ordersLoading: "[orders] Orders loading",
  orderActiveSelected: "[orders] OrderActive selected",
  orderActiveClear: "[orders] OrderActive clear",
  ordersSelected: "[orders] ordersSelected",
  clearOrdersSelected: "[orders] clearOrdersSelected",
  multipleassignOrders: "[orders] multipleassignOrders",

  setMap: "[ui] setMap",
  setCity: "[ui] setCity",
  setCoverage: "[ui] setCoverage",
  //Drivers
  showOrdersDriver: "[ui] showOrdersDriver",
  showDriverFree: "[ui] showDriverFree",
  showDriverBusy: "[ui] showDriverBusy",
  //Orders
  showOrdersInProccess: "[ui] showOrdersInProccess",
  showOrdersReady: "[ui] showOrdersReady",
  showOrdersDispatched: "[ui] showOrdersDispatched",
  showGroup: "[ui] showGoup",
  showOrdersAssigned: "[ui] showOrdersAssigned",
  showOrdersDispatchedMarker: "[ui] showOrdersDispatchedMarker",
  showOrdersUnassigned: "[ui] showOrdersUnassgined",
  showVehicleType: "[ui] showVehicleType",

  offAllSwitchTop: "[ui] off switch top",
  offAllSwitchButtom: "[ui] off switch buttom",

  tapPanelLeftActive: "[ui] activeTabPanelLeft",
  tapPanelRightActive: "[ui] activeTabPanelRight",

  acceptsOrdersActive: "[ui] showActiveOrders",

  isShowAverageOrders: "[ui] isShowAverageOrders",
  isShowAverageOrders: "[ui] isShowAverageOrders",

  ordersMerchantSelected: "[order] getOrdersMerchantSelected",

  // Get timing and search timing //
  getTiming: "[timings] getTiming",
  getTimingSearch: "[timings] getTimingSearch",
  isLoadingTiming: "[timings] isLoading",
  timingActive: "[timings] active",
  driverTimingOnly: "[timings] driverTimingOnly",

  //RECLAMO
  getReclamoLoading: "[reclamo] reclamo loading",
  changeLoading: "[reclamo] change loading",
  setReclamoActivo: "[reclamo] reclamo active",
  clearReclamoActive: "[reclamo] reclamo clear active",

  //MERCHANT
  merchantDetail: "[merchant] merchant detail",
  merchantMapActive: "[merchant] merchant map active",
};
